/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRelationManyToMany = createReactComponent("outline", "relation-many-to-many", "IconRelationManyToMany", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M15 14v-4l3 4v-4", "key": "svg-1" }], ["path", { "d": "M6 14v-4l3 4v-4", "key": "svg-2" }], ["path", { "d": "M12 10.5l0 .01", "key": "svg-3" }], ["path", { "d": "M12 13.5l0 .01", "key": "svg-4" }]]);

export { IconRelationManyToMany as default };
//# sourceMappingURL=IconRelationManyToMany.mjs.map
